import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Common/Header";
import { Card, Button, Affix, Form } from "antd";
import { isMobileView } from "../../../Common/AppHelper";
import { useParams } from "react-router-dom";
import { getData } from "../../../../apiServices/common";
import AddDetailsForm from "./AddDetailsForm";
import { hasPermission } from "../../../../utils/functions";
import { LOCAL_INVOICE_CREATE_PERMISSION } from "../../../../routes/permissions";

export default function EditExportSalesContract(props) {
  // Props
  const { width, view } = props;

  // Router
  let { importId, supplierType } = useParams();
  const propertyFormRef = useRef(null);

  // States
  const [loading, setLoading] = useState(false);
  const [permitInfo, setPermitInfo] = useState();
  const [disableButton, setDisableButton] = useState(false);
  const [disableUpdateButton, setDisableUpdateButton] = useState(false);

  // Antd
  const [form] = Form.useForm();

  const handleUpdate = () => {
    if (!loading) {
      form.submit();
    }
  };

  const edit_url = `/api/accounting/import-detail/view/${importId}`;
  const getPIInfo = async () => {
    let res = await getData(edit_url);
    if (res) {
      let masterData = res?.data?.data[0];
      setPermitInfo(masterData);
    }
  };

  useEffect(() => {
    getPIInfo();
  }, []);

  useEffect(() => {
    if (
      (supplierType == "local" &&
        hasPermission([LOCAL_INVOICE_CREATE_PERMISSION]) &&
        permitInfo?.sales_contract_commercial?.original_documents_receive_date) ||
      (supplierType == "local" && permitInfo?.sales_contract_commercial?.accepted_invoice)
    ) {
      setDisableUpdateButton(true);
    }
  }, [permitInfo, supplierType]);

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title={`${view ? "View" : "Edit"} Import Shipment Status`}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button
                size="small"
                key="update-action"
                type="primary"
                loading={loading}
                onClick={handleUpdate}
                hidden={view}
                disabled={loading || disableButton || disableUpdateButton}
              >
                Update
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <AddDetailsForm
        ref={propertyFormRef}
        permitInfo={permitInfo}
        form={form}
        view={view}
        setLoading={setLoading}
        loading={loading}
        supplierType={supplierType}
        disableButton={disableButton}
        setDisableButton={setDisableButton}
        disableUpdateButton={disableUpdateButton}
      />
    </>
  );
}
